import { render, staticRenderFns } from "./baiberk-maintain.vue?vue&type=template&id=d54c92b2&"
import script from "./baiberk-maintain.vue?vue&type=script&lang=js&"
export * from "./baiberk-maintain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports